import axios from '@/plugins/axios';

const ADV_OPTION = '/advertising-option';

export async function getAdvOption(params) {
  try {
    const { data } = await axios.get(ADV_OPTION, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getAllAdvertisingSection() {
  try {
    const { data } = await axios.get(`${ADV_OPTION}/info/status`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getInfoAdvertisingSection(params) {
  try {
    const { data } = await axios.get(`${ADV_OPTION}/info`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function saveAdvertising(payload) {
  try {
    const { data } = await axios.post(`${ADV_OPTION}/info`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getAdvertisingActive() {
  try {
    const { data } = await axios.get(`${ADV_OPTION}/validate`);

    return data;
  } catch (error) {
    return { error };
  }
}
